<template>
  <div class="collect">
    <div class="team">
      <div class="title flex-center" @click="showHome = !showHome">
        <div class="name">{{ homeTeam.name }}</div>
        <div class="icon">
          {{ showHome ? '折叠' : '展开' }}
          <van-icon name="arrow-down" size="16px" style="margin-left: 6px;" class="is" :class="showHome ? 'van-icon1':''" />
        </div>
      </div>
      <div class="table" v-if="showHome">
        <div class="left">
          <div class="label">球员</div>
          <div v-for="(item, i) in homeTeam.players" :key="i" class="name">{{ item.trueName }}</div>
        </div>
        <div class="right">
          <div class="label">
            <div v-for="(item, i) in list" :key="item" :style="{background: i%2 === 0 ? '#0352E8':'#1565FC'}">{{ item }}</div>
          </div>
          <div class="round">
            <div v-for="(item, i) in homeTeam.players" :key="i" class="item">
              <!-- <div v-for="game,index in list" :key="game" :style="{ background: index % 2 === 0 ? '#F7F7F7' : '#fff' }">{{ index }}</div> -->
              <div>{{ item.goalCount || 0 }}</div>
              <div>{{ item.assistCount || 0 }}</div>
              <div>{{ item.yellowCardCount || 0 }}</div>
              <div>{{ item.redCardCount || 0 }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="team">
      <div class="title flex-center" @click="showAway = !showAway">
        <div class="name">{{ awayTeam.name }}</div>
        <div class="icon">
          {{ showAway ? '折叠' : '展开' }}
          <van-icon name="arrow-down" size="16px" style="margin-left: 6px;" class="is" :class="showAway ? 'van-icon1' : ''" />
        </div>
      </div>
      <div class="table" v-if="showAway">
        <div class="left">
          <div class="label">球员</div>
          <div v-for="(item, i) in awayTeam.players" :key="i" class="name">{{ item.trueName }}</div>
        </div>
        <div class="right">
          <div class="label">
            <div v-for="(item, i) in list" :key="item" :style="{ background: i % 2 === 0 ? '#0352E8' : '#1565FC' }">{{ item }}</div>
          </div>
          <div class="round">
            <div v-for="(item, i) in awayTeam.players" :key="i" class="item">
              <!-- <div v-for="game,index in list" :key="game" :style="{ background: index % 2 === 0 ? '#F7F7F7' : '#fff' }">{{ index }}</div> -->
              <div>{{ item.goalCount || 0 }}</div>
              <div>{{ item.assistCount || 0 }}</div>
              <div>{{ item.yellowCardCount || 0 }}</div>
              <div>{{ item.redCardCount || 0 }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getBMGameDetail, getBMGamePlayerList } from "@/api/match";

export default {
  data() {
    return {
      is: true,
      list: ['进球', '助攻', '黄牌', '红牌'],
      gameId: '',
      homeTeam: {},
      showHome: true,
      awayTeam: {},
      showAway: true
    };
  },
  mounted() {
    this.gameId = this.$route.query.gameId
    this.getBMGamePlayerList()
  },
  methods: {
    getBMGameDetail() {
      getBMGameDetail({ gameId: this.gameId }).then(res => {
        if (res) {
          const { data } = res
          const game = data.game || {}
          this.homeTeam = game.homeTeam
          this.awayTeam = game.awayTeam
        }
      })
    },
    getBMGamePlayerList() {
      const params = {
        gameId: this.gameId
      }
      getBMGamePlayerList(params).then(res => {
        if (res) {
          const { data } = res
          const teams = data.teams || []
          this.homeTeam = teams[0]
          this.awayTeam = teams[1]
        }
      })
    }
  },
};
</script>

<style scoped lang="scss">
.collect{
  min-height: 100vh;
  background: #F6F6F8;
  .title{
    padding: 19px 16px 13px 16px;
    font-size: 14px;
    .name{
      font-weight: 500;
      color: rgba(0,0,0,0.8);
    }
    .icon{
      color: #9A9A9A;
      .is{
        transition: 0.1s linear;
      }
      .van-icon1{
        transform: rotateX(-180deg);
      }
    }
  }
  .table{
    padding-left: 16px;
    display: flex;
    .left{
      .label{
        min-width: 112px;
        box-sizing: border-box;
        background: #1565FC;
        border-radius: 4px 0px 0px 0px;
        padding: 8px 0px 8px 24px;
        color: #fff;
        font-size: 14px;
        text-align: left;
      }
      .name{
        width: 112px;
        height: 53px;
        box-sizing: border-box;
        text-align: center;
        background-color: #fff;
        border-bottom: 1px solid #E6E6E6;
        padding: 16px 0;
        font-size: 14px;
      }
    }
    .right{
      overflow: scroll;
      .label{
        display: flex;
        div{
          min-width: 112px;
          box-sizing: border-box;
          text-align: center;
          background: #0352E8;
          color: #fff;
          font-size: 14px;
          padding: 8px 0;
        }
      }
      .round{
        // display: flex;
        .item{
          display: flex;
          div{
            height: 53px;
            font-size: 14px;
            min-width: 112px;
            padding: 16px 0;
            background-color: #fff;
            border-bottom: 1px solid #E6E6E6;
            box-sizing: border-box;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
